import { resolveApiBaseUrl, resolveUploadUrl } from './apiBase';

const API_BASE_URL = resolveApiBaseUrl();

const absoluteUrl = (val) => resolveUploadUrl(val) || val || '';

export const fetchPortfolio = async ({ page = 1, limit = 12, category } = {}) => {
  try {
    let url = `${API_BASE_URL}/api/portfolio?page=${page}&limit=${limit}`;
    if (category && category !== 'all') url += `&category=${encodeURIComponent(category)}`;
    const res = await fetch(url, { cache: 'no-store' });
    if (!res.ok) {
      console.error('Portfolio API error:', res.status, res.statusText);
      return [];
    }
    const data = await res.json();
    if (!data.success || !Array.isArray(data.data)) {
      return [];
    }
    return data.data
      .map(transformPortfolioToFrontendShape)
      .filter(item => item !== null);
  } catch (error) {
    console.error('Portfolio fetch error:', error);
    throw error;
  }
};

export const fetchPortfolioBySlug = async (slug) => {
  const url = `${API_BASE_URL}/api/portfolio/slug/${encodeURIComponent(slug)}`;
  const res = await fetch(url, { cache: 'no-store' });
  if (!res.ok) return null;
  const data = await res.json();
  if (!data.success || !data.data) return null;
  return data.data;
};

export const fetchPortfolioById = async (id) => {
  const url = `${API_BASE_URL}/api/portfolio/${encodeURIComponent(id)}`;
  const res = await fetch(url, { cache: 'no-store' });
  if (!res.ok) return null;
  const data = await res.json();
  if (!data.success || !data.data) return null;
  return data.data;
};

export const fetchPortfolioCategories = async () => {
  try {
    const url = `${API_BASE_URL}/api/portfolio/categories`;
    const res = await fetch(url, { cache: 'no-store' });
    if (!res.ok) return [];
    const data = await res.json();
    if (!data.success || !Array.isArray(data.data)) return [];
    return data.data;
  } catch (error) {
    console.error('Categories fetch error:', error);
    return [];
  }
};

export const transformPortfolioToFrontendShape = (backendItem) => {
  if (!backendItem) return null;
  try {
    return {
      id: backendItem.id,
      slug: backendItem.slug || backendItem.subtitle || '',
      title: backendItem.title || 'Untitled',
      subtitle: backendItem.subtitle || backendItem.slug || '',
      category: backendItem.category || '',
      client: backendItem.client || '',
      date: backendItem.date || '',
      largeImage: absoluteUrl(backendItem.large_image),
      largeImageAlt: backendItem.large_image_alt || '',
      portfolioImage: absoluteUrl(backendItem.large_image),
      gallery: {
        imageOne: absoluteUrl(backendItem.gallery_image_one)
      },
      galleryImageOneAlt: backendItem.gallery_image_one_alt || '',
      btn: {
        buttontext: backendItem.btn_text || 'View',
        link: backendItem.btn_link || '#'
      },
      body: backendItem.body || ''
    };
  } catch (error) {
    console.error('Error transforming portfolio item:', error, backendItem);
    return null;
  }
};
